import React, { useMemo } from "react";
import SettingsAccordion from "./SettingsAccordion";
import AccountSettings from "./sections/AccountSettings";
import PreferencesCard from "./PreferencesCard";
import PrivacyCard from "./sections/PrivacyCard";
import ContactDeveloperCard from "./sections/ContactDeveloperCard";
import FaqCard from "./sections/FaqCard";

export default function SettingsSections({ role }) {
  const sections = useMemo(
    () => [
      {
        id: "account",
        title: "Account",
        description: "View and manage your profile information.",
        content: <AccountSettings />,
      },
      {
        id: "preferences",
        title: "Preferences",
        description: "Customize notifications, tables, and theme.",
        content: <PreferencesCard role={role} variant="plain" title="Preferences" />,
      },
      {
        id: "privacy",
        title: "Privacy",
        description: "Update your password and privacy-related options.",
        content: <PrivacyCard />,
      },
      {
        id: "contact",
        title: "Contact Developer",
        description: "Send feedback or report an issue.",
        content: <ContactDeveloperCard />,
      },
      {
        id: "faqs",
        title: "FAQs",
        description: "Quick answers to common questions.",
        content: <FaqCard />,
      },
    ],
    [role]
  );

  return <SettingsAccordion sections={sections} defaultOpenId="account" />;
}
